import gql from 'graphql-tag'

import { main, immutable } from './fragments'

export default gql`
mutation updateManyLoyaltyCards($idArr: [ID]!, $fields: LoyaltyCardFields!) {
	cashAssist {
		updateManyLoyaltyCards(idArr: $idArr, fields: $fields) {
			id: idTemp
			mod_ver
			...immutable
			...loyaltyCardMain
		}
	}
}
${main}
${immutable}`
